import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import { useAssetsFieldValues } from '../_load/AssetsFieldValuesLoader'
import { useExecutorFieldValues } from '../_load/ExecutorCertificadoLoader'
import OptionsForm from './options/OptionsForm'
import PdfDocument from './PdfDocument'
import PdfOptionsFormHandler from '../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../../components/pdf/Preview'

// Cor base do texto do documento: preta, como no PDF-modelo real (não o azul-marinho
// padrão do Btime, `COLORS.dark1`, usado antes). Confirmado por inspeção pixel-a-pixel
// do modelo — o corpo de texto do PGR Bradesco é inteiramente preto.
const DOCUMENT_TEXT_COLOR = '#000000'

const PageContent = () => {
  const serviceOrder = useServiceOrder()
  const assets = useAssetsFieldValues()
  const executorFieldValues = useExecutorFieldValues()

  return (
    <PdfOptionsFormHandler initialState={{ fontBaseColor: DOCUMENT_TEXT_COLOR }}>
      <Grid align="stretch">
        <Col flex={3} invisibleOn="mdd" scroll height="calc(100vh - 4.3rem)">
          <Preview>
            <PdfDocument serviceOrder={serviceOrder} assets={assets} executorFieldValues={executorFieldValues} />
          </Preview>
        </Col>

        <Col flex={1}>
          <OptionsForm />
        </Col>
      </Grid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
